import React, { Component } from 'react'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

class QuickView extends Component {
	constructor(props) {
		super(props)

		this.state = {
			count: 1
		}
	}

	hideQuickViewModal = e => {
		document.querySelector('#quickview__modal').classList.remove('show')
	}

	render() {
		return (
			<section id='quickview__modal' class='modal'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div
							id='quickview__window'
							className='col-md-8 align-self-center'>
							<div className='row'>
								<div className='col-md-6'>
									<img
										src='https://placehold.it/300x375'
										alt='placeholder'
									/>
									<ul className='thumbnails'>
										<li>
											<img
												src='https://placehold.it/100x125'
												alt='placeholder'
											/>
										</li>
										<li>
											<img
												src='https://placehold.it/100x125'
												alt='placeholder'
											/>
										</li>
										<li>
											<img
												src='https://placehold.it/100x125'
												alt='placeholder'
											/>
										</li>
									</ul>
								</div>
								<div className='col-md-6'>
									<FAI
										icon='times'
										size='lg'
										onClick={this.hideQuickViewModal}
									/>
									<h4>{this.props.item.title}</h4>
									<p>${this.props.item.price}.99</p>
									<p>
										Lorem ipsum dolor sit amet, consectetur
										adipisicing elit. Maxime, omnis.
									</p>
									<span className='ratings d-flex'>
										<span className='rating'>
											<FAI icon='star' />
											<FAI icon='star' />
											<FAI icon='star' />
											<FAI icon='star' />
											<FAI icon='star-half-alt' />
											&nbsp; 4.5
										</span>
										<span className='reviews text-muted'>
											13 reviews
										</span>
									</span>
									<span className='colors'>
										Colors:
										<ul className='product-colors'>
											<li
												className='product-color active'
												data-color='pink'
											/>
											<li
												className='product-color'
												data-color='forest-green'
											/>
											<li
												className='product-color'
												data-color='yellow'
											/>
											<li
												className='product-color'
												data-color='black'
											/>
										</ul>
									</span>
									<span className='sizes'>
										Sizes:
										<ul className='sizes-list'>
											<li className='size'>xs</li>
											<li className='size'>sm</li>
											<li className='size active'>md</li>
											<li className='size'>lg</li>
											<li className='size'>xl</li>
										</ul>
									</span>
									<span className='quantity'>
										Quantity:&emsp; -&ensp;
										{this.state.count}&ensp;+
									</span>
									<span
										className='btn btn--primary'
										onClick={e => {
											this.props.addToCart(e)

											document
												.querySelector(
													'#quickview__modal'
												)
												.classList.remove('show')
										}}>
										<span className='btn__text'>
											Add to Cart
										</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default QuickView
